import axios from 'axios';
import { getEnv } from '@/environment';
import abonnementApi from './abonnementApi';
import eiendomApi from './eiendomApi';

const altinnrolleApiUrl = getEnv('VUE_APP_ALTINNROLLE_API');
const driftsmeldingApi = getEnv('VUE_APP_DRIFTSMELDING_URL');

const index = {
  getRepresentations() {
    return axios
      .get(`${altinnrolleApiUrl}/representasjoner`, { useBrukerinfo: true })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response));
  },

  getDriftsmeldinger(komponentId) {
    return axios
      .get(`${driftsmeldingApi}/driftsmeldinger/${komponentId}`)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error.response));
  },

  ...abonnementApi,
  ...eiendomApi,
};

export default index;
